<template>
    <div class="version2-top-bottom">
        <Header title="专利运营转化"></Header>
        <Pie :options="options" class="echartsBlock" @echartClick="echartClick"></Pie>
    </div>
</template>
<script>
import Header from '../../commonHeader/one.vue'
import Pie from '@/components/echarts/Pie'
import { getValueRange, getTransferRange } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      options: {},
      rangeList: [],
      transferList: [],
      total: 0
    }
  },
  components: {
    Header,
    Pie
  },
  mounted() {
    this.valueRange()
    this.transferRange()
    // this.pieCharts()
  },
  methods: {
    echartClick(params) {
      this.jumpIpi('法律事件=' + params.data.type, 'isMerge', 'publicOrder')
    },
    imgCount(val) {
      switch (val) {
        case 0:
          return 'imgOne'
        case 1:
          return 'imgTwo'
        case 2:
          return 'imgThree'
        case 3:
          return 'imgFour'
        case 4:
          return 'imgFive'
      }
    },
    transferRange() {
      getTransferRange().then(res => {
        if (res[this.codeMapping]) {
          const list = [
            {
              label: '许可',
              value: 'permit',
              colorStops: [
                {
                  offset: 0,
                  color: '#A658FD' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#3CF2F6' // 100% 处的颜色
                }
              ]
            },
            {
              label: '质押',
              value: 'pledege',
              colorStops: [
                {
                  offset: 0,
                  color: '#A45FFE' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#7D96F8' // 100% 处的颜色
                }
              ]
            },
            {
              label: '转让',
              value: 'transfer',
              colorStops: [
                {
                  offset: 0,
                  color: '#38EFF0' // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: '#779BF8' // 100% 处的颜色
                }
              ]
            }
          ]
          this.transferList = res[this.dataMapping]
          this.transferList.forEach(item => {
            list.forEach(ele => {
              if (item.name === ele.value) {
                item.name = '专利' + ele.label + '/件数' + item.count
                item.value = item.count
                item.type = ele.label
                item.itemStyle = {
                  borderColor: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 1,
                    colorStops: ele.colorStops,
                    global: false // 缺省为 false
                  }
                }
              }
            })
            this.total += item.count
          })
          this.pieCharts()
        }
      })
    },
    valueRange() {
      getValueRange().then(res => {
        if (res[this.codeMapping]) {
          this.rangeList = res[this.dataMapping]
        }
      })
    },
    pieCharts() {
      const dataList = this.transferList
      // const colorList = ['#4D88FE', '#50CCCB', '#FFBF3C']
      const gradList = [

        new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [
          {
            offset: 0,
            color: '#38EFA8'
          },
          {
            offset: 1,
            color: '#79D2FC'
          }
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          {
            offset: 0,
            color: '#85CCFE'
          },
          {
            offset: 1,
            color: '#6557FB'
          }
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          {
            offset: 0,
            color: '#6557FB'
          },
          {
            offset: 1,
            color: '#3FFEB4'
          }
        ])
      ] // 动态渐变颜色
      this.options = {
        tooltip: {
          trigger: 'item',
          formatter(params) {
            const name = params.data.name.replace(/\d+/ig, '')
            return params.marker + ' ' + `${name}&nbsp;&nbsp;&nbsp;&nbsp;<b>` + params.value + '</b>'
          }
        },
        title: {
          text: '专利运用',
          subtext: this.total, // 小标题
          left: '24%',
          top: '45%',
          textAlign: 'center',
          textVerticalAlign: 'middle',
          textStyle: {
            color: '#ffffff',
            fontSize: '15'
          },
          subtextStyle: {
            color: '#ffffff',
            fontSize: '16'
          }
        },
        legend: {
          icon: 'roundRect',
          data: dataList.map((item) => item.name),
          right: '12%',
          top: 'middle',
          orient: 'vertical',
          itemWidth: 1, // 设置宽度
          itemHeight: 35, // 设置高度
          textStyle: {
            fontSize: 14,
            color: '#fff',
            width: 90,
            overflow: 'break',
            padding: [8, 8, 8, 8]
          }
        },
        zlevel: 999,
        series: [{
          // 外圈
          name: '',
          type: 'pie',
          radius: ['55%', '65%'],
          center: ['30%', '50%'],
          itemStyle: {
            normal: {
              borderColor: '#364684',
              borderWidth: 1,
              color: function(params) {
                return gradList[params.dataIndex]
              },
              labelLine: {
                width: 1,
                length: 10,
                length2: 30,
                showAbove: true
              },
              label: {
                color: '#ddd',
                position: 'outside',
                fontSize: 14,
                // overflow: 'none',
                formatter: function(params) {
                  if (params.name !== '') {
                    return params.data.per
                  } else {
                    return ''
                  }
                }
              }
            }
          },
          data: dataList,
          left: '-8%'
        },
        {
          // 内圈
          type: 'pie',
          radius: ['45%', '55%'],
          center: ['30%', '50%'],
          silent: true,
          itemStyle: {
            normal: {
              borderColor: '#364684',
              borderWidth: 1,
              color: '#25CBA5',
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            }
          },
          data: dataList,
          left: '-8%'
        },
        {
          // 内圈
          type: 'pie',
          radius: ['35%', '45%'],
          center: ['30%', '50%'],
          silent: true,
          itemStyle: {
            normal: {
              borderColor: '#364684',
              borderWidth: 1,
              color: '#1AA28C',
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            }
          },
          data: dataList,
          left: '-8%'
        }
        ]
      }
    }
  }
}
</script>
